export default __webpack_public_path__ + "static/media/Achillies.0bcedc9d.png";